module.exports = __webpack_public_path__ + "img/temu_icon.ee0ee906.webp";